module.exports = __webpack_public_path__ + "img/6 lab-test.27e8bbeb.jpeg";